export enum SearchType {
  "query" = "query",
  "recent" = "recent",
  "product" = "product",
  "category" = "category",
  "corrected" = "corrected",
}
